<template>
  <f7-page name="home" @page:beforein="initHome">
    <!-- Top Navbar -->
    <f7-navbar :sliding="false" large>
      <f7-nav-left>
        <f7-link
          icon-ios="f7:menu"
          icon-aurora="f7:menu"
          icon-md="material:menu"
          panel-open="left"
        ></f7-link>
      </f7-nav-left>

      <f7-nav-title sliding right>Miss Comely</f7-nav-title>
      <f7-nav-right>
        <f7-icon f7="bell" slot="right">
          <f7-badge color="red" v-if="total_message > 0">{{
            total_message
          }}</f7-badge>
        </f7-icon>
        <f7-link popover-open=".popover-menu" slot="right">
          <i class="f7-icons">ellipsis_vertical</i>
        </f7-link>
      </f7-nav-right>
      <f7-nav-title-large sliding>Miss Comely</f7-nav-title-large>
      <f7-subnavbar :inner="false">
        <f7-searchbar
          search-container=".search-list"
          search-in=".item-title"
          :disable-button="!$theme.aurora"
        ></f7-searchbar>
      </f7-subnavbar>
    </f7-navbar>
    <f7-list class="searchbar-not-found">
      <f7-list-item title="Nothing found"></f7-list-item>
    </f7-list>
    <f7-list class="search-list searchbar-found" media-list>
      <f7-list-item
        v-for="(frd, index) in friends"
        :key="index"
        :title="frd.name"
        :text="frd.latest_message"
        @click="gotoChat(frd)"
      >
        <f7-badge color="red" slot="after-title" v-if="frd.message_count > 0">{{
          frd.message_count
        }}</f7-badge>

        <img class="small-avatar" slot="media" :src="frd.photo_url1" />
        <span slot="footer" v-if="frd.userStatus == 'online'">
          <i class="f7-icons size-29 color-icon-red">circle_fill</i>&nbsp;<font
            color="green"
            >online</font
          >
        </span>
        <span slot="footer" v-else>
          <i class="f7-icons size-29 color-lightgrey">circle_fill</i>&nbsp;<font
            color="grey"
            >offline</font
          >
        </span>
        <span slot="subtitle" v-if="frd.location">{{ frd.location }}</span>
        <span slot="after-title" v-if="frd.userType == 2 || frd.userType == 3"
          >Moderator</span
        >
      </f7-list-item>
    </f7-list>

    <f7-popover class="popover-menu">
      <f7-list>
        <f7-list-item
          link="/viewprofile/"
          popover-close
          title="Profile"
        ></f7-list-item>
        <f7-list-item
          link="/editProfile/"
          popover-close
          title="Settings"
        ></f7-list-item>

        <f7-list-item
          link="/addPhoto/"
          popover-close
          title="Add Photos"
        ></f7-list-item>

        <!--        <f7-list-item
          link="/postfriends/"
          popover-close
          title="Post Messages"
        ></f7-list-item>-->
        <f7-list-item
          link="/usernotifications/"
          popover-close
          title="Notifications"
        ></f7-list-item>
        <!-- <f7-list-item
          @click="sendBroadCast()"
          popover-close
          title="Send Broadcast Message"
        ></f7-list-item>-->
      </f7-list>
    </f7-popover>

    <f7-popup class="demo-popup-user" backdrop:false>
      <f7-page>
        <f7-navbar
          :title="user_details[0].name"
          :subtitle="user_details[0].location"
        >
          <div slot="default">
            <span :v-if="user_details[0].birthDate">{{
              moment(user_details[0].birthDate, "YYYYMMDD").fromNow(true)
            }}</span>
          </div>
          <f7-nav-right>
            <f7-link popup-close>Close</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block>
          <div class="wrapper">
            <img class="image--cover1" :src="this.user_details[0].photo_url" />
          </div>
          <div class="wrapper">
            <p>
              <b>Profile Message</b>
              <br />
              {{ user_details[0].profileMessage }}
            </p>
          </div>
          <div class="wrapper">
            <p>
              <b>Your Email</b>
              <br />
              {{ this.user_details.email }} --> Only you see this
            </p>
          </div>
          <div class="wrapper">
            <p>
              <b>Your Phone Number</b>
              <br />
              {{ this.user_details.phonenumber }} --> Only you see this
            </p>
          </div>
          <br />
          <br />
        </f7-block>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>


<script>
import firebase from "firebase";
var numeral = require("numeral");

export default {
  data() {
    return {
      //user_details: null
      myAppVersion: 5,
      userEmail: null,
      frd_email: null,
    };
  },

  methods: {
    async refreshChats(value) {
      if (this.chatOpen) {
        //console.log("am here****************", this.user[0].domain);
        //if (this.friend_email == this.friend.email) {
        var payload = {};
        // payload.email_u = this.user[0].email;
        payload.email_u = this.userEmail;
        payload.email_f = value; //this.friend.email;
        payload.domain = this.user[0].domain;

        await this.$store.dispatch("getChatMessages", payload);
        this.$store.dispatch("getTypingMessages", payload);
        //await this.$store.dispatch("getFriendMatch", payload);
        //await this.$store.dispatch("getUserPersonalDetails", payload);
        //await this.$store.dispatch("getFriendList", payload);
        //}
      }
    },
    async refresh() {
      if (this.signed_in && this.chatOpen) {
        this.refreshChats(this.frd_email);
      }
      if (this.signed_in && !this.chatOpen) {
        //console.log("signed_in", this.signed_in);
        var payload = {};
        payload.email = this.userEmail;
        payload.domain = this.user[0].domain;
        await this.$store.dispatch("getFriendMatch", payload);
        await this.$store.dispatch("getUserPersonalDetails", payload);
        await this.$store.dispatch("getFriendList", payload);
        await this.$store.dispatch("getTotalMessage", payload);
      }
    },
    sendBroadCast() {
      this.$f7.popover.close();
      var dialog = this.$f7.dialog
        .create({
          title: "Send Broadcast Message",
          text: "",
          content:
            '<div class="dialog-input-field item-input"><div class="item-input-wrap"><input class="dialog-input" type="text" placeholder="Enter Title"  required maxlength="50"> <div class="item-input-wrap"><input class="dialog-input body" type="textarea" placeholder="Enter Message"  resizable required maxlength="200"></div></div></div>',

          buttons: [{ text: "Cancel", close: true }, { text: "Send" }],
          onClick: (dialog, index) => {
            var title_field = dialog.$el.find(".dialog-input").val().trim();

            var body_field = dialog.$el.find(".body").val().trim();
            if (title_field != "" && body_field != "") {
              var payload = {};
              payload.title = title_field;
              payload.message_details = body_field;
              this.$store.dispatch("pushNotifications", payload);

              var payloadMessage = {
                group_name: this.chat_group_name,
                message:
                  "Broadcast: Title: " +
                  title_field +
                  " Message: " +
                  body_field,
                img: null,
              };
              //this.$store.dispatch("sendGroupMessage", payloadMessage);
              this.$f7.dialog.close();
            } else {
              if (index == 1) {
                this.$store.commit("setAlertMessage", "Fields cannot be empty");
              }
            }
          },
          on: {
            open: function () {},
          },
        })
        .open();
    },
    async checkInternet() {
      if (window.hasOwnProperty("cordova")) {
        let network_status = await this.$store.dispatch("checkConnection");
        if (network_status == "offline") {
          this.$store.commit(
            "setAlertMessage",
            "It seems you are offline. Kindly check internet connection to continue..."
          );
        }
      }
    },
    formatNumber(value) {
      return numeral(value).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
    },
    logoutApp() {
      const app = this.$f7;
      this.$store.dispatch("signOut");
      this.$f7.popover.close();
      app.panel.close();
    },

    gotoChat(frd) {
      this.frd_email = frd.email;
      //console.log(this.frd_email);
      // this.$store.dispatch("getMyFriendsAI");
      var frd_string = JSON.stringify(frd);

      this.$f7router.navigate("/chat/" + encodeURIComponent(frd_string));
    },
    initHome() {
      this.$store.commit("setShowTabs", true);
      this.$store.commit("setChatOpen", false);
      this.frd_email = null;
      //this.$store.commit("setChatMessages", []);
      //this.$store.dispatch("getMyFriendsAI");
    },
  },

  computed: {
    chatOpen() {
      return this.$store.getters.chatOpen;
    },
    advert_default() {
      console.log(
        "******** me if call ***********advert_default()",
        this.$store.getters.advert_default
      );
      return this.$store.getters.advert_default;
    },
    photoStatus() {
      return this.$store.getters.photoStatus;
    },
    user() {
      return this.$store.getters.user;
    },

    app_version() {
      return this.$store.getters.app_version;
    },
    app_db_version() {
      return this.$store.getters.app_db_version;
    },
    user_payout: {
      get: function () {
        return this.formatNumber(this.$store.getters.user_payout);
      },
      set: function (newValue) {
        this.$store.commit("setUserLocation", newValue);
      },
    },
    user_country() {
      return this.$store.getters.user_country;
    },
    subscribe_affiliate() {
      return this.$store.getters.subscribe_affiliate;
    },
    user_details() {
      return this.$store.getters.user_details;
    },
    friends() {
      return this.$store.getters.friends;
    },
    friend_requests() {
      return this.$store.getters.friend_requests;
    },
    message_count() {
      return this.$store.getters.message_count;
    },
    total_message() {
      return this.$store.getters.total_message;
    },
    signed_in() {
      return this.$store.getters.signed_in;
    },
  },

  mounted() {
    // this.$store.dispatch("getTotalMessage");
  },
  watch: {
    photoStatus(value) {
      if (!value) {
        this.$f7router.navigate("/editprofilepicture/", {});
        this.$store.commit(
          "setAlertMessage",
          "Please Upload Profile Picture before chatting with others"
        );
      }
    },
  },

  async created() {
    var payload = {};
    this.userEmail = this.user[0].email;
    payload.email = this.user[0].email;
    //console.log("payload.email", payload.email);
    payload.domain = this.user[0].domain;
    await this.$store.dispatch("getTotalMessage", payload);
    await this.$store.dispatch("getFriendMatch", payload);
    await this.$store.dispatch("getUserPersonalDetails", payload);
    await this.$store.dispatch("getFriendList", payload);
    await this.$store.dispatch("getUserPhotoStatus", payload);
    this.$store.dispatch("getAdvertDefault");

    if (window.hasOwnProperty("cordova")) {
      window.plugins.OneSignal.getIds((userId) => {
        if (userId != null) {
          //write to database
          //console.log("Nosa moses here")
          //write an axios to update users with these values
          //  playerID: userId.userId,
          //pushToken: userId.pushToken

          var payload = {};
          payload.playerID = userId.userId;
          payload.pushToken = userId.pushToken;
          payload.email = this.user[0].email;
          payload.domain = this.user[0].domain;
          this.$store.dispatch("sendOneSignalToken", payload);
        }
      });
      // end of onesignal
    } //if cordova

    setInterval(this.refresh, 10000);

    var photoUpload = await this.$store.dispatch("getUserPhotoStatus", payload);

    if (!photoUpload) {
      this.$f7router.navigate("/editprofilepicture/", {});
      return;
    }
    this.$store.dispatch("getAppVersion");
    if (this.app_version == "Android" || this.app_version == "iOS") {
      this.$store.dispatch("getAppDbVersion");

      if (this.myAppVersion < this.app_db_version) {
        this.$store.commit("setAppUpdate", true);
        this.$f7router.navigate("/newversion/");
        return;
      }
    }
    this.checkInternet();
    // if (!photoUpload) {
    // this.$f7router.navigate("/editprofilepicture/", {});
    //this.$store.commit(
    //  "setAlertMessage",
    //  "Please Upload Profile Picture before chatting with others"
    // );
    //  return;
    // }

    return;

    //this.$store.dispatch("getMyRequests");
    //this.checkInternet2();
    //    this.$store.dispatch("getMyFriendsAI");

    //this.$store.dispatch("getUserDetails");
    //this.$store.dispatch("getUserAffiliate");
    //this.$store.dispatch("getUserPayout");
    //this.$store.dispatch("getUserCountry");
    this.$store.dispatch("getAppDbVersion");

    if (this.myAppVersion < this.app_db_version) {
      this.$store.commit("setAppUpdate", true);
      this.$f7router.navigate("/newversion/");
      return;
    }
    //this.user_payout = this.formatNumber(this.user_payout);
  },
};
</script>
<style>
.small-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
}

.size-29 {
  font-size: 10px;
}

.color-icon-red {
  color: #4cd964;
}
.color-lightgrey {
  color: #d3d3d3;
}

/* Custom color theme */
:root {
  --f7-theme-color: #42a5f5;
  --f7-theme-color-rgb: 66, 165, 245;
  --f7-theme-color-shade: #1b93f3;
  --f7-theme-color-tint: #69b7f7;
}
/* Invert navigation bars to fill style */
:root,
:root.theme-dark,
:root .theme-dark {
  --f7-bars-bg-color: var(--f7-theme-color);
  --f7-bars-bg-color-rgb: var(--f7-theme-color-rgb);
  --f7-bars-translucent-opacity: 0.9;
  --f7-bars-text-color: #fff;
  --f7-bars-link-color: #fff;
  --f7-navbar-subtitle-text-color: rgba(255, 255, 255, 0.85);
  --f7-bars-border-color: transparent;
  --f7-tabbar-link-active-color: #fff;
  --f7-tabbar-link-inactive-color: rgba(255, 255, 255, 0.54);
  --f7-sheet-border-color: transparent;
  --f7-tabbar-link-active-border-color: #fff;
}
.appbar,
.navbar,
.toolbar,
.subnavbar,
.calendar-header,
.calendar-footer {
  --f7-touch-ripple-color: var(--f7-touch-ripple-white);
  --f7-link-highlight-color: var(--f7-link-highlight-white);
  --f7-button-text-color: #fff;
  --f7-button-pressed-bg-color: rgba(255, 255, 255, 0.1);
}
.navbar-large-transparent,
.navbar-large.navbar-transparent {
  --f7-navbar-large-title-text-color: #000;

  --r: 66;
  --g: 165;
  --b: 245;
  --progress: var(--f7-navbar-large-collapse-progress);
  --f7-bars-link-color: rgb(
    calc(var(--r) + (255 - var(--r)) * var(--progress)),
    calc(var(--g) + (255 - var(--g)) * var(--progress)),
    calc(var(--b) + (255 - var(--b)) * var(--progress))
  );
}
.theme-dark .navbar-large-transparent,
.theme-dark .navbar-large.navbar-transparent {
  --f7-navbar-large-title-text-color: #fff;
}

.small-avatar2 {
  width: 50px;
  height: 50px;
  margin: 20px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
}

.wrapper {
  text-align: center;
}

.image--cover1 {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  margin: 5px;
  object-fit: cover;
  object-position: center;
}
</style>




